import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.start');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-start',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.start/view.scss */
:host {
  display: block;
  height: 100%;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fade-in 0.2s ease-out;
}`],
})
export class PageStartComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public showDownload: boolean = false;

    // GitHub Releases 설정
    private readonly GITHUB_OWNER = 'zoeznm';
    private readonly GITHUB_REPO = 'web-pos';

    public downloadUrl: any = {
        mac: '',
        win: '',
    };

    public releaseAvailable: boolean = false;
    public releaseVersion: string = '';

    public async ngOnInit() {
        await this.service.init();

        // GitHub Release 최신 버전 조회
        try {
            const res = await fetch(
                `https://api.github.com/repos/${this.GITHUB_OWNER}/${this.GITHUB_REPO}/releases/latest`,
                { method: 'GET', headers: { 'Accept': 'application/vnd.github.v3+json' } }
            );
            if (res.ok) {
                const data = await res.json();
                this.releaseVersion = data.tag_name || '';
                for (const asset of data.assets || []) {
                    if (asset.name.endsWith('.dmg')) {
                        this.downloadUrl.mac = asset.browser_download_url;
                    } else if (asset.name.endsWith('.exe')) {
                        this.downloadUrl.win = asset.browser_download_url;
                    }
                }
                this.releaseAvailable = !!(this.downloadUrl.mac || this.downloadUrl.win);
            }
        } catch (e) { }

        await this.service.render();
    }

    public async toggleDownload() {
        this.showDownload = !this.showDownload;
        await this.service.render();
    }

    public launchWeb() {
        location.href = '/pos';
    }

    public download(platform: string) {
        const url = this.downloadUrl[platform];
        if (!url) {
            alert('아직 배포된 설치 파일이 없습니다.\n관리자에게 문의하세요.');
            return;
        }
        // <a> 태그를 동적으로 생성하여 다운로드 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}

export default PageStartComponent;